var map = {
	"./dacia1300.jpg": 433,
	"./ferrarif40.jpg": 900,
	"./gtrr32.jpg": 505,
	"./peugeot205.jpg": 621,
	"./peugeot206.jpg": 282,
	"./trueno.jpg": 866
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824;